module.exports = __webpack_public_path__ + "img/CSE.eb9ecbfb.png";